module.exports = __webpack_public_path__ + "img/heart-filled.7a9b5ba6.svg";